// extracted by mini-css-extract-plugin
export default {"card":"g4-z"};